module.exports = __webpack_public_path__ + "static/media/mobileScreenshot06.66bdb118.jpg";